import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// Campos sensíveis que NUNCA devem ir para o localStorage da sessão
const SENSITIVE_FIELDS = ['password', 'confirmPassword', 'citizenId'];

/**
 * Retorna um objeto seguro para salvar na sessão,
 * removendo todos os campos sensíveis.
 */
function toSafeUser(userData) {
  if (!userData || typeof userData !== 'object') return userData;
  const safe = { ...userData };
  SENSITIVE_FIELDS.forEach(field => delete safe[field]);
  return safe;
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const savedUser = localStorage.getItem('lumenfall_user');
      if (savedUser && savedUser !== 'undefined') {
        const parsed = JSON.parse(savedUser);
        if (parsed && typeof parsed === 'object') {
          // Garantir que dados sensíveis não estão no objeto (migração)
          setUser(toSafeUser(parsed));
        }
      }
    } catch (error) {
      console.error('Failed to parse user from localStorage', error);
      localStorage.removeItem('lumenfall_user');
    } finally {
      setLoading(false);
    }
  }, []);

  const login = (userData) => {
    const safeUser = toSafeUser(userData);
    setUser(safeUser);
    // Salvar apenas dados não-sensíveis na sessão
    localStorage.setItem('lumenfall_user', JSON.stringify(safeUser));
    // Se for aluno, salvar dados mínimos de matrícula (sem senha)
    if (userData.type === 'student') {
      localStorage.setItem('lumenfall_enrollments', JSON.stringify([{
        course: userData.courseName || userData.course,
        enrollmentId: userData.enrollmentId,
        turma: userData.turma
      }]));
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('lumenfall_user');
  };

  const updateUser = (newData) => {
    const updatedUser = toSafeUser({ ...user, ...newData });
    setUser(updatedUser);
    localStorage.setItem('lumenfall_user', JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading }}>
      {loading ? (
        <div className="flex items-center justify-center min-h-screen" style={{ background: 'var(--bg)' }}>
          <div className="spinner animate-spin" />
        </div>
      ) : children}
    </AuthContext.Provider>
  );
};
